import { ref, onUnmounted, getCurrentInstance } from 'vue';
import { getLocalValue, removeLocalValue } from "@/hooks/useLocalStorage";

export function useScrollToSelectedCase(delay: number = 1000) {
  const timeoutId = ref<number | null>(null);

  const handleScroll = (): void => {
    const currentSelectedCase = getLocalValue('selected_case_id');
    
    if (currentSelectedCase) {
      const caseElement = document.getElementById(currentSelectedCase);
      if (caseElement) {
        caseElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      removeLocalValue('selected_case_id');
    }
  };

  const startScroll = (): void => {
    timeoutId.value = window.setTimeout(() => {
      handleScroll();
    }, delay);
  };

  // Also called from `router.afterEach`, where there is no component instance:
  // Vue then warns and drops the hook. Registering it only when there IS an
  // instance keeps the cleanup for component callers and changes nothing for
  // the router one, where the hook could never have fired.
  if (getCurrentInstance()) {
    onUnmounted((): void => {
      if (timeoutId.value !== null) {
        clearTimeout(timeoutId.value);
      }
    });
  }

  return {
    handleScroll,
    startScroll,
  };
}